import { GetSuitesType as ApiSuitesType } from 'src/api/generated/touring/types';
import { mapMoneyType } from '../../../common';
import { SuitesType } from '../../types';

export const mapSuitesType = (apiType: ApiSuitesType): SuitesType => {
  return {
    seats: apiType.seats,
    uplift: apiType.uplift ? mapMoneyType(apiType.uplift) : null,
    share: apiType.share ? mapMoneyType(apiType.share) : null,
    notes: apiType.notes,
  };
};
